module.exports = __webpack_public_path__ + "static/media/P2020.91f9656a.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/video/P2020.ogg
// module id = 520
// module chunks = 0